import {dictionaryApi} from 'common/api/entitiesApi'
import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps} from './DictionarySelector'

export const TimeZoneSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="timeZone"
                        loader={() => dictionaryApi.timezone()}
                        errorText="Can't load available time zones"
    />